<template>
  <div class="l-page l-page--message">
    <!-- サイドバーエリア -->
    <page-sidebar />
    <!-- /サイドバーエリア -->
    <main class="l-main">
      <div class="l-main-head">
        <div class="c-title u-w600">
          <div class="c-title__text c-title__text--blue u-fs34">配信メッセージ一括登録</div>
        </div>
      </div>

      <div class="l-main-content">
        <ul style="display: flex;">
          <li>
            <a
              href="/api/message/download-template-excel"
              class="c-btn c-btn--blue u-w196 u-h32 u-fs--s"
              style="width: 250px !important;"
            >テンプレートダウンロード(Excel)</a>
          </li>
        </ul>
        <div class="p-project-btns" style="justify-content: left; margin: 0; position: relative;">

          <div class="c-upload" style="width: auto;">
            <label class="c-upload__label" style="padding: 0; width: auto;">
              <div class="c-upload__data" style="display: inline; padding: 0; width: auto;">
                <input
                  id="fileUploadBtn"
                  name="file"
                  type="file"
                  @change="handleFileObject"
                />
                <span class="c-upload__btn">ファイルの選択</span>
                <span class="c-upload__filename" style="width: auto;">{{ uploadFileName }}</span>
              </div>
            </label>
          </div>

          <button
            v-if="uploadFileSelected"
            class="c-btn c-btn--modal c-btn--blue u-w358 u-h50 u-fs--l"
            :class="{ 'is-loading': isConfirmBtn }"
            :disabled="isConfirmBtn"
            style="position: absolute; top: 0; right: 0;"
            @click="fileUpload"
          >
            <p class="c-btn__text">登録内容を確認する</p></button>

          <button
            v-if="noError"
            class="c-btn c-btn--modal c-btn--blue u-w358 u-h50 u-fs--l"
            :class="{ 'is-loading': isSaveBtn }"
            :disabled="isSaveBtn"
            style="position: absolute; top: 0; right: 0;"
            @click="fileUpload"
          >
            <p class="c-btn__text">登録する</p></button>
        </div>
      </div>
      <div v-if="mimeTypeError" class="c-error__text">アップロードファイルはcsv/xlsx形式のファイルを指定してください。</div>
      <div v-if="fileEmptyError" class="c-error__text">空のファイルがアップロードされました。</div>
      <div v-if="columnNumberError" class="c-error__text">アップロードされたファイルの列数が不正です。テンプレートを利用して下さい。</div>
      <div v-if="importMaxNumberError" class="c-error__text">{{ uploadedNumber }}件のアップロードを検出しました。一度にアップロード出来るのは{{ importMaxNumber }}件までです。</div>

      <div v-if="importData">
        <span v-if="hasError" class="c-error__text">登録内容に誤りがあります。修正内容を確認してください。</span>
        <span v-if="validated">登録可能です。内容に問題無ければ「登録する」を押して下さい。</span>
        <table class="c-table">
          <thead>
            <tr>
              <th class="c-table__cell--center">行番号</th>
              <th class="c-table__cell--center">プッシュ名</th>
              <th class="c-table__cell--center">グループ名</th>
              <th class="c-table__cell--center">タイトル</th>
              <th class="c-table__cell--center">本文</th>
              <th class="c-table__cell--center">クリックURL</th>
              <th class="c-table__cell--center">アイコン画像URL</th>
              <th class="c-table__cell--center">大型画像URL</th>
              <th class="c-table__cell--center">配信条件</th>
              <th class="c-table__cell--center">配信予定</th>
              <th class="c-table__cell--center">配信状況</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(element, index) in importData" :key="index">
              <td>
                {{ index + 1 }}
                <p v-if="element.adFlagError" class="c-error__text">{{ element.adFlagError }}</p>
              </td>
              <td>
                {{ element.messageName }}
                <p v-if="element.messageNameError" class="c-error__text">{{ element.messageNameError }}</p>
              </td>
              <td>
                {{ element.messageGroupName }}
                <p v-if="element.messageGroupNameError" class="c-error__text">{{ element.messageGroupNameError }}</p>
              </td>
              <td>
                {{ element.messageTitle }}
                <p v-if="element.messageTitleError" class="c-error__text">{{ element.messageTitleError }}</p>
              </td>
              <td>
                {{ element.messageText }}
                <p v-if="element.messageTextError" class="c-error__text">{{ element.messageTextError }}</p>
              </td>
              <td>
                {{ element.clickUrl }}
                <p v-if="element.clickUrlError" class="c-error__text">{{ element.clickUrlError }}</p>
                <p v-if="element.clickUrlNotFoundError" class="c-error__text">{{ element.clickUrlNotFoundError }}</p>
              </td>
              <td>
                <span v-if="element.imageUrlValid">
                  <img :src="element.imageUrl" />
                </span>
                <p v-if="element.imageUrlError" class="c-error__text">{{ element.imageUrlError }}</p>
                <p v-if="element.imageUrlNotFoundError" class="c-error__text">{{ element.imageUrlNotFoundError }}</p>
              </td>
              <td>
                <span v-if="element.largeImageUrlValid">
                  <img :src="element.largeImageUrl" />
                </span>
                <p v-if="element.largeImageUrlError" class="c-error__text">{{ element.largeImageUrlError }}</p>
                <p v-if="element.largeImageUrlNotFoundError" class="c-error__text">{{ element.largeImageUrlNotFoundError }}</p>
              </td>
              <td>
                {{ element.condition }}
                <p v-if="element.conditionError" class="c-error__text">{{ element.conditionError }}</p>
              </td>
              <td>
                {{ element.messageDeliverSendStartDate }}
                {{ element.messageDeliverSendStartTime }}
                <p v-if="element.messageDeliverSendStartDateError" class="c-error__text">{{ element.messageDeliverSendStartDateError }}</p>
                <p v-if="element.messageDeliverSendStartDatetimeError" class="c-error__text">{{ element.messageDeliverSendStartDatetimeError }}</p>
                <p v-if="element.messageDeliverSendStartTimeError" class="c-error__text">{{ element.messageDeliverSendStartTimeError }}</p>
              </td>
              <td>
                {{ element.deliverStatus }}
                <p v-if="element.deliverStatusError" class="c-error__text">{{ element.deliverStatusError }}</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </main>

    <!-- モーダル: 配信設定完了メッセージ表示 -->
    <control-modal
      ref="refCompleteModal"
      classes="c-modal--result"
      :body="completeMessage"
      cancel-button-label="メッセージ一覧へ"
      :is-active=isCompleteMessage
      :on-close-click="onCloseControlModal"
      :on-cancel-click="onCancelControlModal"
    />

  </div>
</template>

<script>
import axios from 'axios';

export default {
  data: function() {
    return {
      fileInfo: null,
      uploadFileName: null,
      importData: null,
      uploadFileSelected: false,
      isProcessing: false,
      hasError: false,
      noError: false,
      fileEmptyError: false,
      mimeTypeError: false,
      columnNumberError: false,
      importMaxNumber: null,
      uploadedNumber: null,
      importMaxNumberError: false,
      validated: false,
      isConfirmBtn: false,
      isSaveBtn: false,
      completeMessage: '',
      isCompleteMessage: false,
      acceptableMimeTypes: [
        'text/csv',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      ],
    }
  },
  methods: {
    handleFileObject(event) {
      this.fileInfo = event.target.files[0];
      this.mimeTypeError = false;
      this.fileEmptyError = false;
      this.uploadFileSelected = true;
      this.validated = false;
      this.uploadFileName = this.fileInfo.name;
      this.noError = false;
      this.columnNumberError = false;
      this.importMaxNumberError = false,
      this.importData = null;
      document.getElementById("fileUploadBtn").value = "";
      if (!this.isAcceptableMimeType(this.fileInfo.type)) {
        this.mimeTypeError = true;
        this.uploadFileSelected = false;
        return;
      }
    },
    fileUpload() {
      this.importData = null;
      const rows = [];
      const formData = new FormData();

      formData.append('file', this.fileInfo);

      // バリデーションエラーが無かったら登録処理へ
      if (this.validated) {
        this.isSaveBtn = true;
        axios.post('/api/message/store', formData, {})
          .then(_response => {
            this.isSaveBtn = false;

            this.isCompleteMessage = true;
            this.completeMessage = 'プッシュ通知の配信設定が完了しました。';
          })
          .catch(_e => {

          })
        return;
      } else {

        this.isConfirmBtn = true;
        axios.post('/api/message/import-confirm', formData, {

        })
          .then(response => {
            // ファイルの中身が空
            if(response.data[0].file_empty_error) {
              this.fileEmptyError = true;
              this.uploadFileSelected = false;
              document.getElementById("fileUploadBtn").value = "";
              this.uploadFileName = null;
              return;
            }

            // レコード件数上限オーバー
            if(response.data[0].import_max_number_error) {
              this.importMaxNumber = response.data[1].import_max_number;
              this.uploadedNumber = response.data[2].uploaded_number;
              this.importMaxNumberError = true;
              this.uploadFileSelected = false;
              document.getElementById("fileUploadBtn").value = "";
              this.uploadFileName = null;
              return;
            }

            // ファイルの列数エラー
            if(response.data[0].column_number_error) {
              this.columnNumberError = true;
              this.uploadFileSelected = false;
              document.getElementById("fileUploadBtn").value = "";
              this.uploadFileName = null;
              return;
            }

            // 入力値エラー
            if(response.data[0].has_error) {
              // サーバ側でエラーフラグを付与しているので外す
              response.data.shift();
              this.hasError = true;
              this.uploadFileSelected = false;
              document.getElementById("fileUploadBtn").value = "";
              this.uploadFileName = null;
            } else {
              this.hasError = false;
              this.noError = true;
              this.validated = true;
              this.uploadFileSelected = false;
            }

            response.data.forEach(element => {
              const row = {
                messageName: element.message_name,
                messageGroupName: element.group_name,
                messageTitle: element.message_title,
                messageText: element.message_text,
                clickUrl: element.click_url,
                imageUrl: element.image_url,
                imageUrlValid: element.image_url_valid,
                largeImageUrl: element.large_image_url,
                largeImageUrlValid: element.large_image_url_valid,
                condition: element.condition,
                messageDeliverSendStartDate: element.message_deliver_send_start_date,
                messageDeliverSendStartTime: element.message_deliver_send_start_time,
                deliverStatus: element.deliver_status,

                messageNameError: element.message_name_error,
                messageGroupNameError: element.group_name_error,
                messageTitleError: element.message_title_error,
                messageTextError: element.message_text_error,
                clickUrlError: element.click_url_error,
                clickUrlNotFoundError: element.click_url_not_found_error,
                imageUrlError: element.image_url_error,
                imageUrlNotFoundError: element.image_url_not_found_error,
                largeImageUrlError: element.large_image_url_error,
                largeImageUrlNotFoundError: element.large_image_url_not_found_error,
                conditionError: element.condition_error,
                messageDeliverSendStartDateError: element.message_deliver_send_start_date_error,
                messageDeliverSendStartTimeError: element.message_deliver_send_start_time_error,
                messageDeliverSendStartDatetimeError: element.message_deliver_send_start_datetime_error,
                deliverStatusError: element.deliver_status_error,

                adFlagError: element.ad_flag_error,
              };
              rows.push(row);
            });

            this.importData = rows;
          })
          .catch(_e => {

          }).finally(() => {
            this.isConfirmBtn = false;
          })
      }
    },
    isAcceptableMimeType: function (mimeType) {
      var isAcceptable = false;
      this.acceptableMimeTypes.forEach(function (acceptableMimeType) {
        if (acceptableMimeType == mimeType) {
          isAcceptable = true;
        }
      });
      return isAcceptable;
    },

    // -----------------------------------------------------------------------------------------------------
    // エミット系メソッド一覧: 子孫のUI操作にフックエミットコールされるか、引き渡した関数オブジェクトからコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    // クリック: 完了モーダルを閉じる処理
    onCloseControlModal() {
      this.isCompleteMessage = false;
      this.validated = false;
      this.noError = false;
      document.getElementById("fileUploadBtn").value = "";
      this.uploadFileName = "";
    },
    // クリック: 完了モーダルを閉じる処理
    onCancelControlModal() {
      this.isCompleteMessage = false;
      location.href = "/coins-admin/message";
    },
  }
}
</script>